import { createReducer } from 'redux-act';
import {
  putData,
  failPutData,
  successPutData,
  setData,
  checkEmail,
  failCheckEmail,
  successCheckEmail,
  checkUser,
  failCheckUser,
  successCheckUser,
  reAnswer,
  failReAnswer,
  successReanswer,
} from '../actions/exam';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
const initial = {
  isFetching: false,
  data: undefined,
  isLoggedIn: false,
  email: undefined,
  authcode: undefined,
  error: undefined,
};

const data = createReducer(
  {
    [putData]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failPutData]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successPutData]: (state, payload) =>
      Object.assign({}, state, payload, {
        isFetching: false,
        error: undefined,
      }),
    [setData]: (state, payload) => Object.assign({}, state, payload),
    [checkEmail]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        authcode: undefined,
        error: undefined,
      }),
    [failCheckEmail]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successCheckEmail]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        authcode: payload.authcode,
        error: undefined,
      }),
    [reAnswer]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        customer: undefined,
        error: undefined,
      }),
    [failReAnswer]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successReanswer]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        email: payload.email,
        data: payload.data,
        isLoggedIn: true,
        error: undefined,
      }),
    [checkUser]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        customer: undefined,
        error: undefined,
      }),
    [failCheckUser]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successCheckUser]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        //data: payload.data,
        error: undefined,
      }),
  },
  initial
);

export default data;



// WEBPACK FOOTER //
// ./src/reducers/exam.js